
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F96481","d":"M42.76 39.91l27.17-20.14A3.26 3.26 0 0066.71 17H13.33c-1.67 0-3 1.22-3.23 2.77L37.27 39.9a4.56 4.56 0 005.5 0z"}}),_c('path',{attrs:{"fill":"#E95843","d":"M42.76 39.91a4.66 4.66 0 01-5.49 0L10.1 19.77c-.03.16-.1.29-.1.45v38.75c0 1.77 1.5 3.22 3.33 3.22h53.34A3.28 3.28 0 0070 58.97V20.19c0-.16-.07-.3-.1-.45L42.76 39.9z"}}),_c('path',{attrs:{"fill":"#F6CFC9","d":"M42.76 39.91l27.17-20.14A3.26 3.26 0 0066.71 17H13.33c-1.67 0-3 1.22-3.23 2.77L37.27 39.9a4.56 4.56 0 005.49 0z"}})])
          )
        }
      }
    